import React from "react";
import { Route, Routes } from "react-router-dom";
import { privateRoutes, publicRoutes } from "./AllRoutes";
import ProtectedLayout from "Layouts/ProtectedLayout";

const Index = () => {
  return (
    <>
      <Routes>
        {privateRoutes?.map((route, i) => (
          <Route
            key={i}
            element={
              <>
                <ProtectedLayout> {route.Component} </ProtectedLayout>
              </>
            }
            path={route.path}
          />
        ))}
        {publicRoutes?.map((route, i) => (
          <Route key={i} element={<> {route.Component} </>} path={route.path} />
        ))}
      </Routes>
    </>
  );
};

export default Index;
